import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetInvitationsResponseBody } from '../InvitationsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseOrganizationInvitationsQueryValues = {
  organizationId: string;
};

export const organizationInvitationsQueryKeyFactory: IQueryKeyFactory<
  IUseOrganizationInvitationsQueryValues
> = (values) =>
  values && (['organizationInvitations', values.organizationId] as const);

export const useOrganizationInvitationsQuery = (
  values?: IUseOrganizationInvitationsQueryValues,
  options?: UseQueryOptions<IApiGetInvitationsResponseBody, ApiError>,
): UseQueryResult<IApiGetInvitationsResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: organizationInvitationsQueryKeyFactory(values),
    queryFn: values
      ? () => api.invitations.getAllForOrganization(values.organizationId)
      : undefined,
    ...options,
  });
};
